import React from 'react'
import './nonBrandedSolutions.scss'
import HeroSection,{CtaBrand} from './../components/heroSection';
import { adsBrand } from '../../../common/utils/constant';
import { SectionWrapper } from '../../../theme/layouts/MainLayout';
import AppImage from '../../../common/features/image';
// const {page4:{hero}} = adsBrand;

function NonBrandedSolutions() {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div className='page-4'>
      <HeroSection data={adsBrand.solutions}/>
      <SectionWrapper>
      <div className="page-container">     
      <section className='section1' title='Full-funnel solutions'>
          <div className="context-section">
            <h3>Full-funnel solutions</h3>
            <p>Reach and engage your customers with our data-driven solutions across the entire sales funnel—like awareness ads on CTV, social media moments that expand the conversation and product experiences on BestBuy.com and the Best Buy app that help you seal the deal.</p>
              <p className='second-para'>However your brand wants to be a part of the customer journey, we have an advertising solution for you. </p>
          </div>
        </section>
        <section className='section2'>
          <div className="context-section" title='In-store, online and wherever they may be'>
            <h3>In-store, online and wherever they may be</h3>
            <p>Our omnichannel solutions ensure you can reach the right customer with the right message at the right time. In addition to ad solutions across the open web and BestBuy.com, we have experiences customers can enjoy from the comfort of their living rooms to 1,000+ stores across North America. </p>
          </div>
          <div className="image">
            <AppImage src="/images/adsLandingPages/Image.png" alt="" />
            <p className='image-text-section'>Our Blue Shirts specialize in bringing the latest tech products to life for customers.</p>
          </div>
        </section>
        <section className='section3'>
          <div className="context-section" title='Measure success at every stage'>
            <h3>Measure success at every stage</h3>
            <p>We capture billions of data points to create greater return on interaction. With an approximately 90% revenue identification rate, we can prove the path from ad exposure to purchase for your most relevant CE audiences. <br /><br />
              And for advertisers who demand more customization, our self-service opportunities give partners extra levers to pull to influence their campaigns.  </p>
          </div>

          <div className="image">
            <AppImage src="/images/adsLandingPages/ClosedLoopReporting.png" alt="" />
            <p className='image-text-section'>Work with our Reporting & Insights team to track the success of your campaigns.</p>
          </div>
        </section>
        <section className='section4'>
          <div className="context-section" title='Relationships are the answer'>
            <h3>Relationships are the answer</h3>
            <p>Ready to start driving results with our data-driven retail media solutions? <a href='javascript:void(0)' className='energy-purple' onClick={scrollToTop}>Fill out the form</a> above to connect with a retail media expert today and learn more about reaching CE shoppers.</p>
          <CtaBrand iconFile={'/images/common/icons/cheveron-up-purple.png'}/>
          </div>
        </section> 
      </div>
      </SectionWrapper>
    </div>
  )
}

export default NonBrandedSolutions